// extracted by mini-css-extract-plugin
export default {"wrap":"QuizStepper_wrap__3bIoU","top":"QuizStepper_top__8AqN4","step":"QuizStepper_step__Y+VNd","text":"QuizStepper_text__RMvvI","holder":"QuizStepper_holder__L-fg3"};